import React, { useState } from 'react';

import styled from '@emotion/styled';

import { Container } from '../../components/Container';
import { media } from '../../services/media';
import { parseHTML } from '../../services/parseHTML';
import { Storyblok, StoryblokSection } from '../../storyblok';

export function SimpleTabs({
    sectionData,
}: StoryblokSection<Storyblok.Component.SimpleTabs>) {
    const [selectedItem, setSelectedItem] = useState<string>('');

    if (!sectionData) {
        return null;
    }

    const { heading, items } = sectionData;
    return (
        <Section>
            <Container size="960px">
                <h2>{heading}</h2>
                <Navigation>
                    {items.map((item, index) => (
                        <NavigationItem
                            key={index}
                            onClick={() => setSelectedItem(item.name)}
                        >
                            <div>{parseHTML(item.icon)}</div>
                            <div>{parseHTML(item.name)}</div>
                        </NavigationItem>
                    ))}
                </Navigation>
                <Content>
                    {items.map(
                        (item) =>
                            item.name === selectedItem && (
                                <ContentItem key={item.name}>
                                    {parseHTML(item.content, 'markdown')}
                                </ContentItem>
                            ),
                    )}
                </Content>
            </Container>
        </Section>
    );
}

const Section = styled.section`
    background-color: #2a3a56;
    color: #e0e0da;
    padding: 60px 0;

    svg {
        fill: #d6d6d6;
        max-width: 52px;
        height: 100%;
        min-height: 50px;
        margin-right: 20px;
    }
`;

const Navigation = styled.div`
    display: grid;

    gap: 20px;
    margin: 0 0 60px;

    ${media.max('lg')} {
        grid-template-columns: 1fr;
    }

    ${media.min('lg')} {
        grid-template-columns: 1fr 1fr 1fr;
    }
`;

const NavigationItem = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: opacity 250ms;

    &:hover {
        opacity: 0.8;
    }
`;
const Content = styled.div`
    margin: 0 0 40px;
`;

const ContentItem = styled.div``;
